var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExiledLockup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1016.95 387.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "380.8 382.74 452.17 382.74 452.17 156.59 380.8 180.5 380.8 382.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "459.05 6.54 387.68 6.54 387.68 152.68 416.48 166.26 416.48 166.26 459.05 152 459.05 6.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "383.15 152.68 383.15 175.91 411.95 166.26 411.95 166.26 383.15 152.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "541.69 320.2 541.69 136.77 515.22 135.46 470.12 150.57 470.12 382.74 625.14 382.74 631.52 320.2 541.69 320.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "545.65 125.28 519.19 134.15 545.65 135.46 545.65 125.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "716.42 319.9 716.42 218.6 793.03 218.6 793.03 155.77 716.42 155.77 716.42 74.33 797.09 74.33 797.09 11.13 644.85 11.13 644.85 382.74 682.39 382.74 778.38 319.9 716.42 319.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m916.35,382.74c84.57,0,98.12-56.05,98.12-120.09v-94.63l-72.68,47.57v62.28c0,28.99-4.65,47.27-32.66,47.27h-13.94v-79.04l-71.57,46.85v89.79h92.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1016.95 137.1 944.27 204.28 944.27 210.92 1016.95 163.34 1016.95 137.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "815.39 316.54 787.54 316.54 715.64 363.61 708.6 379.38 806.81 379.38 815.39 316.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "688.47 381.77 705.53 381.77 712.56 366 688.47 381.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m907.42,11.13h-87.87v268.12l40.94-13.1h0s30.63-20.05,30.63-20.05V69.09h13.38c27.06,0,33.22,14.93,33.22,42.37v97.49l72.68-67.17v-18.82c0-76.93-26.41-111.83-102.98-111.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "815.39 283.85 815.39 297.55 856.32 270.75 856.33 270.75 815.39 283.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "479.26 141.58 550.82 117.6 550.82 37.44 479.26 23.92 479.26 141.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "483.41 0 483.41 21.78 554.97 35.3 554.97 0 483.41 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m369.18,387.15l-17.59-59.59-64.26,31.06c2.94,13.88,5.08,24.72,5.36,28.53h76.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m309.25,185.44L363.21,11.13h-71.81c-.59,8.61-23.75,107.64-24.53,117.81h-2.12c-.39-9.78-22.15-109.4-22.75-117.81h-76.29l53.93,186.31-55.93,185.3h72.03c.98-11.15,26.98-115.7,27.56-127.83h1.93c.73,9.83,10.1,51.6,17.34,85.04l39.88-3.55,27.44-13.26-40.64-137.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m280.58,356.45l36.82-17.8-39.88,3.55c1.08,4.98,2.11,9.77,3.06,14.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "71.57 216.8 148.18 216.8 148.18 153.97 71.57 153.97 71.57 141.3 71.57 126.55 71.57 72.52 152.24 72.52 152.24 9.33 0 9.33 0 136.43 0 165.93 0 261.6 71.57 246.28 71.57 216.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2.33 382.74 155.13 382.74 163.71 319.9 73.9 319.9 73.9 285.82 73.9 248.08 2.33 263.4 2.33 303.24 2.33 382.74"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExiledLockup);
export default __webpack_public_path__ + "static/media/exiled_lockup.73686788c3b6d26d84d9aeb8eb9cee49.svg";
export { ForwardRef as ReactComponent };